module.exports = __webpack_public_path__ + "static/media/logout-red.a455cee3.svg";